import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

export const stringLengthValidation = (length: number, lettersOnly?: boolean) => [
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (value && lettersOnly && !/^[A-Za-z]+$/.test(value))
                return Promise.reject(<TranslateText>VALIDATION_LETTERS_ONLY_ERR</TranslateText>);
            if (!value || value.length === length) return Promise.resolve();
            if (value) return Promise.reject(<TranslateText params={[length]}>LENGTH_VALIDATION_ERR</TranslateText>);
            return Promise.resolve();
        }
    })
];

export default stringLengthValidation;
